module.exports = __webpack_public_path__ + "img/conny-f-stage6-sulking.9d3595ea.png";